import { BaseDTO } from './basedto';
import { PartInfoInProposal } from './partinfoinproposal';
import { PackageInfo } from './packageinfo';
import { ProposalImage } from './proposal-image';
import { ProposalDocument } from './proposal-document';
import { ProposalWarning } from './proposal-warning';
import { ProposalLocation } from './internal/proposal-location';


export class Proposal extends BaseDTO {
    RejectionCount: number;
    ProposalId: number;
    PartInfo: PartInfoInProposal;
    PackageInfo: PackageInfo;
    ManufacturingLocation: ProposalLocation;
    SecondaryProcessingLocation: ProposalLocation;
    ImageInfo: ProposalImage[];
    DocumentInfo: ProposalDocument[];
    WarningInfo: ProposalWarning[];
    ExternalComment: string = '';
    WorkflowStatusModifiedDate: Date;
    CreatedOn: Date;
    ModifiedOn: Date;
    CreatedByUserName: string;
    ModifiedByUserName: string;
    EngineerUserName: string;
    AssignedEngineerUserName: string;
    AckUpdate: boolean;

    ContainerTotalWeight: number;
    WeightUtilization: number;
    CubeUtilization: number;
    TotalPartQuantity: number;
    LowUtilizationComments: string;
    IncompleteComments: string;
    PendingValidationComments: string;
    IsLatestActiveProposal: boolean;
    constructor() {
        super();
        this.PartInfo = new PartInfoInProposal();
        this.PackageInfo = new PackageInfo();
        this.ManufacturingLocation = new ProposalLocation();
        this.SecondaryProcessingLocation = new ProposalLocation();
        this.ImageInfo = [];
        this.DocumentInfo = [];
        this.WarningInfo = [];
    }
}
